if (!customElements.get('wool-pet-personalization')) {
  customElements.define('wool-pet-personalization', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller=new AbortController();
      const options={signal:this.controller.signal};
      this.form=this.closest('form');this.confirm=this.querySelector('[data-wool-confirm]');this.error=this.querySelector('[data-wool-error]');
      this.slots=[...this.querySelectorAll('[data-wool-slot]')].map(element=>({element,input:element.querySelector('[data-wool-photo]'),preview:element.querySelector('[data-wool-preview]'),status:element.querySelector('[data-wool-status]'),error:element.querySelector('[data-wool-photo-error]'),version:0,ready:false,url:null}));
      this.fields=[...this.querySelectorAll('input[type="text"],textarea')];
      this.form.addEventListener('input',event=>{if(event.target!==this.confirm)this.confirm.checked=false;this.validateText();},options);
      this.form.addEventListener('change',event=>{if(event.target!==this.confirm)this.confirm.checked=false;const slot=this.slots.find(s=>s.input===event.target);if(slot)this.loadPhoto(slot);},options);
      this.slots.forEach(slot=>{slot.element.querySelector('[data-wool-remove]').addEventListener('click',()=>{slot.input.value='';this.confirm.checked=false;this.loadPhoto(slot);},options);if(slot.input.files.length)this.loadPhoto(slot);});
      this.form.addEventListener('submit',event=>this.add(event),{...options,capture:true});
      this.updateProgress();this.dataset.ready='true';
    }

    validateText() {this.fields.forEach(field=>field.setCustomValidity(field.value.length>field.maxLength?this.dataset.textError:''));}

    updateProgress() {
      const count=this.slots.filter(slot=>slot.ready).length;
      this.querySelector('[data-wool-progress]').textContent=this.dataset.readyLabel.replace('[count]',count);
      this.querySelector('[data-wool-progress-bar]').style.width=(count/4*100)+'%';
    }

    async loadPhoto(slot) {
      const version=++slot.version;
      if(slot.url)URL.revokeObjectURL(slot.url);
      slot.url=null;slot.ready=false;slot.preview.hidden=true;slot.preview.removeAttribute('src');slot.status.textContent='';slot.error.hidden=true;this.error.hidden=true;
      slot.input.setCustomValidity('');slot.input.removeAttribute('aria-invalid');
      slot.element.querySelector('[data-wool-placeholder]').hidden=false;
      slot.element.querySelector('[data-wool-choose]').hidden=false;slot.element.querySelector('[data-wool-replace]').hidden=true;
      const file=slot.input.files[0];slot.element.querySelector('[data-wool-remove]').hidden=!file;this.updateProgress();
      if(!file)return;
      const invalid=()=>{slot.input.value='';slot.input.setCustomValidity(this.dataset.photoError);slot.input.setAttribute('aria-invalid','true');slot.error.textContent=this.dataset.photoError;slot.error.hidden=false;slot.status.textContent='';};
      if(!['image/jpeg','image/png','image/webp'].includes(file.type)||!file.size||file.size>10*1024*1024){invalid();return;}
      const url=URL.createObjectURL(file);slot.url=url;slot.status.textContent=this.dataset.loading;slot.input.setCustomValidity(this.dataset.loading);
      try {
        const image=new Image();image.src=url;await image.decode();
        if(version!==slot.version||!this.isConnected)return;
        if(!image.naturalWidth||image.naturalWidth*image.naturalHeight>80000000)throw new Error('Invalid photo');
        slot.ready=true;slot.preview.src=url;slot.preview.hidden=false;slot.status.textContent=file.name;slot.input.setCustomValidity('');
        slot.element.querySelector('[data-wool-placeholder]').hidden=true;
        slot.element.querySelector('[data-wool-choose]').hidden=true;slot.element.querySelector('[data-wool-replace]').hidden=false;
      } catch {
        if(version!==slot.version||!this.isConnected)return;
        URL.revokeObjectURL(url);slot.url=null;invalid();
      } finally {if(version===slot.version)this.updateProgress();}
    }

    async add(event) {
      event.preventDefault();event.stopImmediatePropagation();
      const submit=this.form.querySelector('[data-product-submit]');
      if(this.busy||submit.disabled)return;
      this.validateText();if(!this.form.reportValidity())return;
      if(!this.slots.every(slot=>slot.ready)){this.error.textContent=this.dataset.photoError;this.error.hidden=false;return;}
      const data=new FormData(this.form);
      this.fields.forEach(field=>{const value=field.value.trim();if(value)data.set(field.name,value);else data.delete(field.name);});
      this.busy=true;submit.disabled=true;this.error.hidden=true;this.setAttribute('aria-busy','true');
      const label=submit.querySelector('[data-submit-label]');label.textContent=this.dataset.uploading;
      try {
        const response=await fetch(new URL(this.form.action,location.origin).pathname.replace(/\/$/,'')+'.js',{method:'POST',headers:{Accept:'application/json'},body:data});
        if(!response.ok)throw new Error('Add failed');
        await response.json();document.dispatchEvent(new CustomEvent('echoes:cart-refresh',{detail:{open:true}}));
      } catch {this.error.textContent=this.dataset.addError;this.error.hidden=false;}
      finally {this.busy=false;this.removeAttribute('aria-busy');submit.disabled=this.form.querySelector('[data-product-variant]').selectedOptions[0].dataset.available!=='true';label.textContent=submit.disabled?submit.dataset.unavailableLabel:submit.dataset.availableLabel;}
    }

    disconnectedCallback() {this.controller?.abort();this.controller=null;this.slots?.forEach(slot=>{slot.version++;if(slot.url)URL.revokeObjectURL(slot.url);});}
  });
}
